export const CustomEvents = {
  LOGIN: 'login',
  PASSWORD_RECOVER: 'password_recover',
  DOCUMENTATION_SEND: 'documentation_send',
  OPEN_WHATSAPP: 'open_whatsapp',
  OPEN_TWITTER: 'open_twitter',
  OPEN_FACEBOOK: 'open_facebook',
  OPEN_INSTAGRAM: 'open_instagram',
  DOWNLOAD_APP_IOS: 'download_app_ios',
  DOWNLOAD_APP_ANDROID: 'download_app_android',
  CIRCULATION_CARD_VIEW: 'circulation_card_view',
  PAYMENTS_VIEW: 'payments_view',
  EXPIRED_PAYMENTS_VIEW: 'expired_payments_view',
  COMPLAINTS_VIEW: 'complaints_view',
  PROFILE_UPDATE: 'profile_update',
  ASSISTANCE_REQUESTED: 'assistance_requested',
  ASSISTANCE_CANCEL: 'assistance_cancel',
  ASSISTANCE_FINISHED: 'assistance_finished',
  MP_PENDING_PAYMENT: 'mp_pending_payment',
  MP_MATURITIES_PAYMENT: 'mp_maturities_payment',
  ENDORSEMENTS_BASE: 'endorsement_',
  SELF_INSPECTION_REQUEST: 'self_inspection_request',
  SELF_INSPECTION_VALIDATE: 'self_inspection_validate',
  SELF_INSPECTION_UNFINISHED: 'self_inspection_unfinished',
  SELF_INSPECTION_OPEN: 'self_inspection_open',
  SELF_INSPECTION_ERROR: 'self_inspection_error',
  SELF_INSPECTION_FINISHED: 'self_inspection_finished',
  COMPLAINTS_ROBBERY_NOT_APPEARED: 'complaints_robbery_not_appeared',
  COMPLAINTS_ROBBERY_APPEARED: 'complaints_robbery_appeared',
  COMPLAINTS_PARTIAL_DAMAGE: 'complaints_partial_damages',
  COMPLAINTS_CRASH_INJURED: 'complaints_crash_injured',
  COMPLAINTS_CRASH_NOT_INJURED: 'complaints_crash_not_injured',
  COMPLAINTS_SUCCESS: 'complaints_success',
  IN_MAINTENANCE_MESSAGE: 'in_maintenance_message',
  PAYMENTS_VIEW_VEHICLE_ONLY: 'payments_view_vehicle_only',
  PAYMENTS_VIEW_OTHER_PRODUCTS: 'payments_view_other_products',
  PAYMENT_METHOD_CHANGE_CONFIRM: 'ENDORS_PAYM_METHOD_CONFIRM',
  PAYMENT_METHOD_CHANGE_SUCCESS: 'ENDORS_PAYMENT_METHOD_CHANGE_SUCCSESS',
  PAYMENT_METHOD_CHANGE_FAILURE: 'ENDORS_PAYMENT_METHOD_CHANGE_FAILURE',
  ACCOUNT_CANCEL_POLICY: 'Account_cancel_policy',
};
